import { getRequest } from "@components/config/axiosClient";
import { hireSaving, updatePrices, resetToken, sectionCounter, getProduct } from "@components/config/requests";
import CacheFactory from "@components/Factories/CacheFactory";

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../useAuth";
import useGeneralActions from "../useGeneralActions";
import useCartDispatch from "./useCartDispatch";
import useCheckoutDeliveryDispatch from "../Checkout/Delivery/useCheckoutDeliveryDispatch";
import useCheckoutQuoteDispatch from "../Checkout/Quote/useCheckoutQuoteDispatch";
import useCheckoutDetailsDispatch from "../Checkout/Details/useCheckoutDetailsDispatch";
import { useProductExtras } from "@components/Components/Providers/ProductExtrasContext";
import { round } from "@components/config/helpers";


const initialState = {

};

const useCartHandler = () => {
    const dispatch = useDispatch();
    const { cart, cartUpdating, updatingPrices, retrievingQuote, swappingProduct, addonProduct } = useSelector((state) => state.cartManagementReducer);
    const pricing_model = useSelector((state) => state.globalReducer.pricing_model);
    const { details } = useSelector((state) => state.checkoutDetailsReducer);
    const { isAuthenticated, getUser } = useAuth();
    const isFirstInit = useRef(false);

    const {
        RESET_CART,
        UPDATE_CART,
        UPDATE_CART_COUNTER,
        SET_TOKEN,
        SET_TOP_CART_MODAL,
        SET_CART_LOADER,
        SET_PRICES_LOADER,
        UPDATE_CART_KEY,
        RETRIEVE_QUOTE_LOADER,
        SET_SWAPPING_LOADER,
        UPDATE_CART_INDEX,
    } = useCartDispatch();

    const { RESET_DETAILS } = useCheckoutDetailsDispatch();
    const { RESET_QUOTE } = useCheckoutQuoteDispatch();
    const { RESET_DELIVERY } = useCheckoutDeliveryDispatch();

    const { setPageSpinner } = useGeneralActions();
    const { extrasSelected } = useProductExtras();

    const [localQty, setLocalQty] = useState(1);
    const [checkForAddons, setCheckForAddons] = useState(false);

    const [localCart, setLocalCart] = useState({
        content: [],
        totals: {},
        hireSaving: {},
        addonProducts: null,
        VATFlag: true,
        counter: 0,
        cartChanged: false
    });

    useEffect(() => {
        setLocalCart(cart);
    }, [cart])

    useEffect(() => {
        if (checkForAddons && !cartUpdating && !updatingPrices) {

            // cart.addonProduct.forEach(function(addon){
            //     if (addon.productId){
            //         addToCart(addon.productId,addon.slug,parseInt(localQty), null, null, null, addon.source);
            //     }
            // });
        }

        return () => {
        }
    }, [checkForAddons, cartUpdating, updatingPrices])

    // REDUX ACTIONS

    // FUNCTIONS

    const createCartCopy = (cartCopy = cart) => {
        return structuredClone(cartCopy);
    }

    const updateCartState = (newCart, source) => {
        if (source && (source == 'planner' || source == 'complementary')) {
            updateCart(newCart, 'site');
        }
        else {
            updateCart(newCart, 'site')
        }
    }

    const buildProductObject = async (baseProduct, qty) => {
        const measurements = {
            height: 60,
            width: 60
        }
        const productReq = await getProduct(baseProduct.slug, measurements.height, measurements.width, true);
        const product = productReq.data;
        const price = parseFloat(product?.all_in_price && pricing_model == 1 ? product.all_in_price : product.price);
        const itemPrice = parseFloat(price).toFixed(2)
        const subtotal = parseFloat(parseInt(qty) * parseFloat(product.price)).toFixed(2)
        const newProductObject = {
            id: product.product_id,
            data: {
                ...product,
                product_extras_to_group_id: baseProduct?.product_extras_to_group_id || null
            },
            qty: parseInt(qty),
            price: itemPrice,
            subtotal: subtotal,
            bow: null,
            pad: null,
            color: null,
            extras: {}
        }

        return {
            cartProduct: newProductObject,
            productRes: product
        }
    }

    const checkForExistingProduct = async (arrayToCheckAgainst, product, qty, source, extrasOverride = null) => {
        // Find matching product and init initial variables
        const existingCartItemIndex = arrayToCheckAgainst.findIndex((item) => item.id == product.id);
        const cartItemExists = existingCartItemIndex !== -1;
        let toReturn = null;
        let mainProductRes = null;


        // handle popups
        if (source === 'complementary') { SET_TOP_CART_MODAL(false); }
        else {
            SET_TOP_CART_MODAL(true, 'cart', "Item added. You're only 2 clicks away from getting a quote!");
            SET_CART_LOADER(false);
        }

        // function to handle extras (if any)
        const mergeExtras = async (item) => {
            let extrasIndex = extrasSelected?.[item.id];
            if (extrasOverride) {
                extrasIndex = extrasOverride[item.id] || extrasOverride;
            }
            if (!extrasIndex) return item;
            const updatedItem = { ...item, extras: { ...(item.extras || {}) } };

            // async so that there are no race conditions and all states are correctly updated
            for (const key of Object.keys(extrasIndex)) {
                if (!updatedItem.extras[key]) updatedItem.extras[key] = [];
                const foundExtra = extrasIndex[key];

                // If the value is none, it doesn't count as an extra
                if (!foundExtra || foundExtra.value === "None" || foundExtra.value === "none") continue;
                const existingExtraIndex = updatedItem.extras[key].findIndex((e) => e.id == foundExtra.value);

                // Inc qtys if this is not false (-1)
                if (existingExtraIndex !== -1) {
                    const existingExtra = { ...updatedItem.extras[key][existingExtraIndex] };
                    existingExtra.qty = parseInt(existingExtra.qty) + parseInt(qty);
                    updatedItem.extras[key][existingExtraIndex] = existingExtra;
                } else if (foundExtra.value && foundExtra.product_slug) {
                    // query api for new product and add to array
                    const extraItem = {
                        id: foundExtra.value,
                        slug: foundExtra.product_slug,
                        product_extras_group_id: foundExtra.product_extras_group_id,
                        product_extras_to_group_id: foundExtra.product_extras_to_group_id
                    };
                    const newExtraData = await buildProductObject(extraItem, qty);
                    const extraCartProduct = newExtraData.cartProduct;
                    mainProductRes = newExtraData.productRes;
                    updatedItem.extras[key].push(extraCartProduct);
                }
            }

            return updatedItem;
        };

        // Existing cart item
        if (cartItemExists) {
            let prevArray = [...arrayToCheckAgainst];
            let existingItem = { ...prevArray[existingCartItemIndex] };
            existingItem.qty = parseInt(existingItem.qty) + parseInt(qty);
            existingItem = await mergeExtras(existingItem);
            mainProductRes = existingItem.data;
            prevArray[existingCartItemIndex] = existingItem;
            toReturn = prevArray;
            UPDATE_CART_KEY('content', toReturn);
        } else {
            // New cart item
            const newProductData = await buildProductObject(product, qty);
            const cartProduct = newProductData.cartProduct;
            mainProductRes = newProductData.productRes;

            let newProjectObject = {
                ...cartProduct,
                extras: { ...(cartProduct.extras || {}) },
            };

            newProjectObject = await mergeExtras(newProjectObject);

            const newContent = [...arrayToCheckAgainst, newProjectObject];
            toReturn = newContent;
            UPDATE_CART_KEY('content', newContent);
        }

        return {
            content: toReturn,
            product_added: mainProductRes,
        };
    };

    const addToCart = async (productID, slug, qty, source, section_id, extrasOverride = null) => {
        setLocalQty(qty);
        sectionCounter(section_id);
        SET_CART_LOADER(true);
        SET_PRICES_LOADER(true);

        if (!qty) {
            qty = 1;
        }

        const actual_source = typeof source == 'undefined' ? false : source;

        let cartCopy = createCartCopy();

        const newItem = {
            id: productID,
            slug: slug
        }

        const handleProduct = await checkForExistingProduct(cartCopy.content, newItem, qty, actual_source, extrasOverride)
        const { content, product_added } = handleProduct;
        cartCopy.content = content;
        cartCopy.counter = updateCartCounter(cartCopy);
        cartCopy = handleAddonProducts(cartCopy, product_added, qty, actual_source);

        let contentCopy = cartCopy.content;
        for (const addon of cart.addonProduct) {
            if (addon.productId) {
                contentCopy = await sortAddonProduct(contentCopy, addon, qty);
                cartCopy.content = contentCopy;
                UPDATE_CART_KEY('content', contentCopy);

                const newCount = updateCartCounter(cartCopy);
                cartCopy.counter = newCount;
                cartCopy.content = contentCopy;
                updateCartState(cartCopy);
            }
        }

        cartCopy.content = contentCopy;
        updateCartState(cartCopy);
    }

    const handleSwapProduct = async (index, extraData = null, newProduct) => {
        let cartCopy = createCartCopy();
        SET_CART_LOADER(true);
        SET_PRICES_LOADER(true);
        SET_SWAPPING_LOADER(true);

        let extraType,
            extraIndex;

        if (extraData != null) {
            extraType = extraData.extraType;
            extraIndex = extraData.extraIndex;
            const prevProduct = cartCopy.content[index].extras[extraType][extraIndex];
            const builtProduct = await buildProductObject({ ...newProduct, slug: newProduct.product_slug }, prevProduct.qty);
            const swappedProduct = builtProduct.cartProduct;
            cartCopy.content[index].extras[extraType][extraIndex] = swappedProduct;
        }
        else {
            const prevProduct = cartCopy.content[index];
            const builtProduct = await buildProductObject({ ...newProduct, slug: newProduct.product_slug }, prevProduct.qty);
            const swappedProduct = builtProduct.cartProduct;
            cartCopy.content[index] = swappedProduct;
        }

        UPDATE_CART_KEY('content', cartCopy.content);
        cartCopy.counter = updateCartCounter(cartCopy);
        updateCartState(cartCopy);
        updateTotals(cartCopy, 'checkout')
    }

    const handleAddonProducts = (newCart, product, qty, source) => {
        let cartCopy = createCartCopy(newCart);

        if ((typeof product.addons !== 'undefined') || (product.addons.length > 0)) {
            cartCopy.addonProducts = {
                qty: qty,
                product: product,
                addons: []
            };

            product.addons.forEach((prod) => {
                cartCopy.addonProducts.addons.push(prod)
            });
        }
        else {
            cartCopy.addonProducts.addons = [];
        }

        UPDATE_CART_KEY('addon_products', cartCopy?.addon_products || [])

        return cartCopy;
    }


    const sortAddonProduct = async (newContent, addon, qty) => {
        let contentCopy = structuredClone(newContent);

        const newItem = {
            id: addon.productId
        }

        const foundItemIndex = newContent.findIndex((item) => item.id == newItem.id)
        const exists = foundItemIndex !== -1;

        if (exists) {
            contentCopy[foundItemIndex].qty = parseInt(contentCopy[foundItemIndex].qty) + parseInt(qty);
        }

        else if (!exists) {
            const measurements = {
                height: 60,
                width: 60
            }

            const productReq = await getProduct(addon.slug, measurements.height, measurements.width, true);
            const product = productReq.data;

            contentCopy.push({
                id: addon.productId,
                data: product,
                qty: parseInt(qty),
                price: parseFloat(product.price),
                subtotal: parseInt(qty) * parseFloat(product.price),
                bow: null,
                pad: null,
                color: null,
                pads: [],
                extras: {}
            });

            // ADD PADD COUNT
            // UPDATE_CART_KEY('content', contentCopy);
        }

        return contentCopy;


    }

    const bulkAddToCart = async (products = []) => {
        SET_CART_LOADER(true);
        SET_PRICES_LOADER(true);

        const measurements = {
            height: 60,
            width: 60
        }
        const promises = products.map(item => getProduct(item.slug, measurements.height, measurements.width)); // Create an array of promises
        const promises_ = await Promise.all(promises); // Wait for all promises to resolve
        let cartCopy = createCartCopy();

        SET_TOP_CART_MODAL(true, 'cart', "Item added. You're only 2 clicks away from getting a quote!");
        SET_CART_LOADER(false);

        const _data = promises_.map((promise, idx) => {
            if (promise?.data != '') {
                const product = promise.data;
                const price = parseFloat(product?.all_in_price && pricing_model == 1 ? product.all_in_price : product.price);
                const qty = parseInt(products[idx].qty);
                const name = products[idx].name == null ? '' : ` (${products[idx].name})`;
                const subtotal = qty * parseFloat(price);

                const foundItemIndex = cartCopy.content.findIndex((item) => item.id == product.product_id && item.data.product_name != name)
                const exists = foundItemIndex !== -1;

                if (!exists) {
                    const new_name = products[idx]?.overridden_str || '';
                    cartCopy.content.push({
                        id: product.product_id,
                        data: {
                            ...product,
                            product_name: `${product.product_name}${new_name}`
                        },
                        qty: qty,
                        price: parseFloat(price),
                        subtotal: subtotal,
                        bow: false,
                        pad: false,
                        color: false,
                        pads: [],
                        extras: {},
                    });
                }
                else {
                    const foundProduct = cartCopy.content[foundItemIndex];
                    cartCopy.content[foundItemIndex].qty = (foundProduct.qty + qty);
                }

            }
        });


        UPDATE_CART_KEY('content', cartCopy.content);
        cartCopy.counter = updateCartCounter(cartCopy);
        updateCartState(cartCopy);

    }

    const setCart = (content) => {
        let cartCopy = createCartCopy();
        cartCopy.content = content;
        updateTotals(cartCopy, 'site')
    }

    const getCart = () => {
        // return CacheFactory.get('cart');
        return cart;
    }

    const removeFromCart = async (mainIndex, typeIndex = null, type = null, source = 'checkout') => {
        SET_PRICES_LOADER(true);

        const cartCopy = createCartCopy();
        const main = cartCopy.content?.[mainIndex];

        if (!main) {
            SET_PRICES_LOADER(false);
            return;
        }

        // --------- CASE 1: Remove an extra (pads/bows/etc.) ----------
        if (typeIndex !== null && type !== null) {
            // Support both schemas:
            // - New: main.extras[type] -> array
            // - Old: main[type]        -> array
            const isNewSchema = !!(main.extras && typeof main.extras === 'object');
            const extrasArray = isNewSchema ? main.extras?.[type] : main?.[type];


            if (!extrasArray[typeIndex]) {
                // invalid index or missing extras
                SET_PRICES_LOADER(false);
                return;
            }

            const removed = extrasArray[typeIndex];
            const removedQty = parseInt(removed?.qty, 10) || 0;

            // Splice the extra
            extrasArray.splice(typeIndex, 1);

            // Write back / clean up the empty group
            if (isNewSchema) {
                if (extrasArray.length === 0) {
                    delete main.extras[type];
                } else {
                    main.extras[type] = extrasArray;
                }
            } else {
                if (extrasArray.length === 0) {
                    delete main[type];
                } else {
                    main[type] = extrasArray;
                }
            }

            // Determine if ANY extras remain (across all groups)
            const hasAnyExtras = isNewSchema
                ? Object.values(main.extras || {}).some(arr => Array.isArray(arr) && arr.length > 0)
                : Object.keys(main).some(k => {
                    const v = main[k];
                    // treat any array of line-items (with data/price/subtotal) as an extras group
                    return Array.isArray(v) && v.length > 0 && (v[0]?.data || v[0]?.price || v[0]?.subtotal);
                });

            if (!hasAnyExtras) {
                // No extras left at all -> remove main product entirely (your rule)
                cartCopy.content.splice(mainIndex, 1);
            } else {
                // Still has some extras: reduce main qty by the removed extra's qty, but never below 1
                const currentMainQty = parseInt(main.qty, 10) || 1;
                main.qty = Math.max(currentMainQty - removedQty, 1);

                // Optionally: also enforce your "min = number of extra groups" rule here
                // const extraGroupCount = isNewSchema
                //     ? Object.keys(main.extras || {}).length
                //     : Object.keys(main).filter(k => Array.isArray(main[k]) && main[k].length > 0 && (main[k][0]?.data || main[k][0]?.price || main[k][0]?.subtotal)).length;
                // main.qty = Math.max(main.qty, Math.max(extraGroupCount, 1));
            }

            UPDATE_CART(cartCopy);
            cartCopy.counter = updateCartCounter(cartCopy);
            updateCart(cartCopy, source);
            SET_PRICES_LOADER(false);
            return;
        }

        // --------- CASE 2: Remove the main product ----------
        cartCopy.content.splice(mainIndex, 1);

        if (cartCopy.content.length > 0) {
            UPDATE_CART(cartCopy);
            cartCopy.counter = updateCartCounter(cartCopy);
            updateCart(cartCopy, source);
        } else {
            SET_TOP_CART_MODAL(false);
            clearCart();
        }

        SET_PRICES_LOADER(false);
    };




    const updateTotals = (newCart, source, type) => {
        // cartchanged =  true
        let cartCopy = createCartCopy(newCart);

        if (source != 'checkout') {
            cartCopy.cartChanged = true;
        }

        if (source == 'checkout' && type) {
            // get cache
        }


        cartCopy.totals.productTotal = 0;
        const weeks = CacheFactory.has('hireWeeks') ? CacheFactory.get('hireWeeks') : 1;

        cartCopy.content.forEach((item, idx) => {
            if (!CacheFactory.has('hireWeeks')) {
                item.subtotal = item.qty * item.price;
            }
            else {
                item.subtotal = item.qty * item.price * weeks;
            }

            let extraGroupsSubTotal = 0;
            if (item.extras && typeof item.extras === 'object') {
                Object.keys(item.extras).forEach((key, idx) => {
                    if (Array.isArray(item.extras[key])) {
                        item.extras[key].forEach((extra, idx) => {
                            extra.subtotal = extra.qty * extra.price * weeks;
                            const extraSubTotal = item.extras[key].reduce((subTotal, extra) => {
                                return (round(subTotal) + round(extra.subtotal));
                            }, 0);
                            extraGroupsSubTotal += extraSubTotal;
                        })
                    }
                })
            }
            cartCopy.totals.productTotal += (item.subtotal + extraGroupsSubTotal);
        });


        cartCopy.totals.productTotal = parseFloat(cartCopy.totals.productTotal);
        UPDATE_CART_KEY('totals', cartCopy.totals);
        // TODO: dispatch for totals

        // getHireSaving
        getHireSaving(cartCopy, source);

        // updateTotals

    }

    const updateCartCounter = (newCart = cart) => {
        const totalQuantity = newCart.content.reduce((totalQty, item) => {
            let itemQty = parseInt(item.qty);
            if (item.extras && typeof item.extras === 'object') {
                for (const key of Object.keys(item.extras)) {
                    const extrasArray = item.extras[key];
                    if (Array.isArray(extrasArray)) {
                        const extrasQty = extrasArray.reduce((subTotalQty, extra) => {
                            return subTotalQty + parseInt(extra.qty, 10);
                        }, 0);
                        itemQty += extrasQty;
                    }
                }
            }
            return totalQty + itemQty;
        }, 0);

        UPDATE_CART_COUNTER(totalQuantity);
        return totalQuantity;
    };


    const changeProductQty = (idx, extrasData = null, qty, setQtyUpdating = false) => {
        let cartCopy = createCartCopy();
        const product = cartCopy.content[idx];

        SET_PRICES_LOADER(true);
        if (!validateQty(qty) || qty <= 0) {
            SET_PRICES_LOADER(false);
            return;
        }

        const updateProductQty = (newQty) => {
            cartCopy.content[idx].qty = Math.max(newQty, 1);
        };

        const updateExtraQty = (type, extraIdx, newQty) => {
            const itemExtras = cartCopy.content[idx]?.extras;
            if (itemExtras?.[type]?.[extraIdx]) {
                itemExtras[type][extraIdx].qty = Math.max(newQty, 0);
            }
        };

        // Changing of an extra
        if (extrasData && Object.keys(extrasData).length > 0) {
            const { type, idx: extraIdx } = extrasData;
            const extraItem = product.extras?.[type]?.[extraIdx];

            if (extraItem) {
                const diff = qty - extraItem.qty;

                updateExtraQty(type, extraIdx, qty);

                // Reflect diff to main product
                const newMainQty = product.qty + diff;
                updateProductQty(newMainQty);
            }

            // Prevents falling into CASE 2 recalculation
            if (typeof setQtyUpdating === "function") {
                setQtyUpdating({ product: null, extrasData: null });
            }

            cartCopy.counter = updateCartCounter(cartCopy);
            updateCart(cartCopy, "checkout");
            return;   // <-- REQUIRED FIX
        }

        // changing main product
        else {
            const diff = qty - product.qty;
            const itemExtras = cartCopy.content[idx]?.extras;

            if (itemExtras && Object.keys(itemExtras).length > 0) {
                const extraGroups = Object.keys(itemExtras);
                const minQty = extraGroups.length; // main product cannot go below this

                if (qty < minQty) {
                    // stop at minimum and reduce first extra if needed
                    const firstGroup = extraGroups[0];
                    const firstExtras = itemExtras[firstGroup];

                    if (Array.isArray(firstExtras) && firstExtras.length > 0) {
                        const firstExtra = firstExtras[0];
                        const reduction = minQty - qty; // how far we tried to go below
                        const newExtraQty = Math.max(firstExtra.qty - reduction, 1);
                        updateExtraQty(firstGroup, 0, newExtraQty);
                    }

                    updateProductQty(minQty); // stop at min
                    SET_PRICES_LOADER(false);
                    cartCopy.counter = updateCartCounter(cartCopy);
                    updateCart(cartCopy, "checkout");
                    return;
                }

                updateProductQty(qty);

                // Mirror diff to first extra in each group
                for (const key of extraGroups) {
                    const extrasArray = itemExtras[key];
                    if (Array.isArray(extrasArray) && extrasArray.length > 0) {
                        const firstExtra = extrasArray[0];
                        const newExtraQty = parseInt(firstExtra.qty || 0) + diff;
                        updateExtraQty(key, 0, newExtraQty);
                    }
                }
            } else {
                updateProductQty(qty);
            }
        }

        if (typeof setQtyUpdating === "function") {
            setQtyUpdating({ product: null, extrasData: null });
        }

        cartCopy.counter = updateCartCounter(cartCopy);
        updateCart(cartCopy, "checkout");
    };

    const updateCache = (newCart, source) => {
        CacheFactory.put('cart', newCart);
        if (source == 'modifiers') {
            // helper.hideLoader();
        } else if (source == 'site') {
            // $rootScope.$broadcast('cartUpdated', 'yes');
            // helper.hideLoader();
        } else {
            // $rootScope.$broadcast('cartUpdated', 'yes');
        }
        // setLocalCart(newCart);
        UPDATE_CART(newCart);

        setCheckForAddons((prevState) => !prevState);

        if (!cartUpdating) SET_CART_LOADER(false);
        if (!updatingPrices || updatingPrices) SET_PRICES_LOADER(false);
        if (!retrievingQuote) RETRIEVE_QUOTE_LOADER(false);

    }

    const validateQty = (qty) => {
        if (Math.floor(qty) == qty && !isNaN(qty) && qty > 0) {
            return true;
        } else {
            return false;
        }
    }

    const incProductQty = (idx) => {
        let cartCopy = createCartCopy();
        const product = cartCopy.content[idx];
        if (product.qty > 1) {
            newCart.content[idx] = { ...product, qty: product.qty + 1 };
            updateCartCounter(cartCopy);
            updateCart(cartCopy, 'checkout')
        }
    }

    const decProductQty = (idx) => {
        let cartCopy = createCartCopy();
        const product = cartCopy.content[idx];
        if (product.qty > 1) {
            newCart.content[idx] = { ...product, qty: product.qty - 1 };
            updateCartCounter(cartCopy);
            updateCart(cartCopy, 'checkout')
        }
    }

    const updateCart = async (newCart, source, type) => {

        let cartCopy = createCartCopy(newCart);
        const products = [];
        if (source == 'checkout' && type) {
            // CacheFactory.get('cart')
        }

        cartCopy.content.forEach((item, key) => {
            products.push({
                id: item.data.product_id,
                qty: item.qty
            });
        });

        let data = {
            'products': products,
            'hire-days': (CacheFactory.has('hireDays') ? CacheFactory.get('hireDays') : 8),
            'brand': process.env.brand.brand_key,
            'include_all_in': pricing_model == 1,
            'version': 'two'
        };

        if (isAuthenticated) {
            const user = getUser();
            if (user?.details != null && Object.keys(user.details).length > 0) {
                const userDetails = user.details;

                const discount = userDetails?.discounts?.find((discount) => discount.user_account_discount_type_id == 1 || discount.user_account_discount_slug == 'product-price')?.discount_value || false;
                if (discount) {
                    data.discount_multiplier = discount;
                }
            }
        }

        if (details?.deliveryDate && details.deliveryDate != "") {
            data.deliveryDate = details.deliveryDate;
        }
        if (details?.collectionDate && details.collectionDate != "") {
            data.collectionDate = details.collectionDate;
        }

        const product_prices = await updatePrices(data);
        cartCopy.content.forEach((item, key) => {
            let updated_price = null;
            if (data.version == 'one') {
                updated_price = product_prices.data[item.data.product_id];
            }
            else if (data.version == 'two') {
                const responseData = product_prices.data;
                const std = responseData.standard_prices[item.data.product_id];
                const updated = responseData.updated_prices[item.data.product_id];
                const price_changed = responseData.prices_changed[item.data.product_id];
                const smart_pricing_id = responseData.smart_pricing_id[item.data.product_id];
                const smart_pricing = responseData.smart_pricing[item.data.product_id];

                updated_price = updated;
                if (price_changed) {
                    item.data.smart_pricing = {
                        discount: (updated < std),
                        previous: std,
                        current: updated,
                        smart_pricing_id,
                        smart_price: smart_pricing,
                    }
                }
            }
            if (updated_price != null) {
                item.price = parseFloat(updated_price);
            }
        })

        UPDATE_CART_KEY('content', cartCopy.content);
        SET_CART_LOADER(false);
        SET_SWAPPING_LOADER(false);
        updateTotals(cartCopy, source, type)


    }

    const updateCartHttp = async (source) => {
        let cartCopy = createCartCopy()
        const products = [];;

        cartCopy.content.forEach((item, key) => {
            products.push({
                id: item.data.product_id,
                qty: item.qty
            });
        });

        const data = {
            'products': products,
            'hire-days': (CacheFactory.has('hireDays') ? CacheFactory.get('hireDays') : 8),
            'brand': process.env.brand.brand_key
        };

        const product_prices = await updatePrices(data);
        return product_prices;

    }

    const clearCart = async () => {
        SET_CART_LOADER(true);
        RESET_CART();
        CacheFactory.clear();

        const request = await resetToken();
        const response = request.data;
        CacheFactory.put('token', response)

        SET_TOKEN(response);
        CacheFactory.put('hireDays', 8);
        CacheFactory.put('hireWeeks', 1); //empty the cart cache

        RESET_DETAILS()
        RESET_DELIVERY()
        RESET_QUOTE()

        SET_CART_LOADER(false);
    }

    const getTotalWeight = (currentCart = cart.content) => {
        return currentCart.reduce((totalWeight, item) => {
            let itemWeight = parseFloat(item.data.weight) * parseInt(item.qty);

            if (item.extras && typeof item.extras === 'object') {
                for (const key of Object.keys(item.extras)) {
                    const extrasArray = item.extras[key];
                    if (Array.isArray(extrasArray)) {
                        const extrasWeight = extrasArray.reduce((subTotal, extra) => {
                            const extraWeight = parseFloat(extra.data.weight || 0) * parseInt(extra.qty || 0);
                            return subTotal + extraWeight;
                        }, 0);
                        itemWeight += extrasWeight;
                    }
                }
            }
            return totalWeight + itemWeight;
        }, 0);
    };


    const getHireSaving = async (newCart, source, type) => {
        let cartCopy = createCartCopy(newCart);
        const data = {
            product_total: newCart.totals.productTotal,
            hireDays: CacheFactory.has('hireDays') ? CacheFactory.get('hireDays') : 8,
        }

        const hireSavingReq = await hireSaving(data);
        cartCopy.hireSaving = {
            value: hireSavingReq.data.value,
            percentage: hireSavingReq.data.percentage,
        }

        UPDATE_CART_KEY('hireSaving', cartCopy.hireSaving);
        cartCopy.totalWeight = getTotalWeight(cartCopy.content);

        UPDATE_CART_KEY('totalWeight', cartCopy.totalWeight);
        updateCache(cartCopy, source)

    }

    const updateCartProductKey = async (index, extraData = null, data, content = cart.content, update = false, baseCart = cart) => {

        let cartCopy = structuredClone(baseCart);
        let contentCopy = structuredClone(content);

        if (extraData == null) {
            cartCopy.content[index] = data;
            contentCopy[index] = data;
        }
        else {
            cartCopy.content = contentCopy;
        }

        UPDATE_CART_KEY('content', contentCopy);

        if (update) {
            updateTotals(cartCopy, 'checkout')
        }

        return await data;
    }


    const completeQuoteFromMessage = (messageID, token) => {

    }

    const switchVAT = () => {

    }

    const setAddonProducts = (productsArray) => {
        let cartCopy = createCartCopy();
        cartCopy.addonProducts = productsArray;
        updateCache(productsArray);
    }

    const getAddonProducts = () => {
        return cart.addonProducts.addons;
    }

    const getAddonProductQty = () => {
        return cart.addonProducts.qty;
    }




    return {
        dispatch: {
            RESET_CART,
            UPDATE_CART
        },
        addToCart,
        setCart,
        getCart,
        removeFromCart,
        updateTotals,
        updateCartCounter,
        changeProductQty,
        handleSwapProduct,
        updateCache,
        validateQty,
        incProductQty,
        decProductQty,
        updateCart,
        updateCartHttp,
        clearCart,
        getTotalWeight,
        getHireSaving,
        completeQuoteFromMessage,
        switchVAT,
        setAddonProducts,
        getAddonProducts,
        getAddonProductQty,
        updateCartProductKey,
        bulkAddToCart
    }
}

export default useCartHandler;